import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { Product } from '../../domain/product';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-review-job-request',
  templateUrl: './review-job-request.component.html',
  styleUrls: ['./review-job-request.component.scss']
})
export class ReviewJobRequestComponent implements OnInit {
  products: Product[];
  items: MenuItem[];

  constructor(private productService: ProductService) { }

  ngOnInit() {
    this.productService.getProductsSmall().then(data => this.products = data);
    this.items = [
      {label: 'Menu'},
      {label: 'Menu Active'},
  ];
}

}
